export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((label, i) => ({
    value: String(i),
    label,
}));

/** "daily 07:00", "Mondays 07:00", "every 6h from 07:00". */
export const frequencyLabel = (frequency: string | null, triggerTime: string | null, dayOfWeek: number | null): string => {
    const at = triggerTime ? ` ${triggerTime.slice(0, 5)}` : '';
    if (frequency === 'WEEKLY') return `${DAYS[dayOfWeek ?? 1]?.label ?? 'Weekly'}s${at}`;
    if (frequency === 'EVERY_12H') return `every 12h from${at}`;
    if (frequency === 'EVERY_6H') return `every 6h from${at}`;
    return `daily${at}`;
};
